import type { PlantOrder, SubscriptionListItem } from '@/shared/data-types';

// 발전소 행의 구독 상태 → 화면 행위 판정. 페이지(인사 분기)와 카드(변형 선택)가 공유.
//
// 정책(확정 — decisions §1·§3·§4·§5):
//   - 미구독/해지(canceled)/만료(expired) → 구독 변형. 미구독=신규 "구독하기", 해지·만료=재구독 "재구독하기".
//   - 결제 변경 = 정기결제(빌링키) 구독 이면 상태 무관 항상. 기준 = 주문 타입 `order.type === 'billing'`
//     (plant 응답 `include=order`). 과거 subscriptionCode 'mon' 임시 proxy 에서 전환 완료.

/** 구독하기(신규/재구독) 대상인가 — 미구독(subscription 부재·inactive)이거나 해지/만료. */
export function isPlantSubscribable(item: SubscriptionListItem): boolean {
  const status = item.subscription?.status;
  return !status || status === 'inactive' || status === 'canceled' || status === 'expired';
}

/** 재구독인가 — 해지/만료(과거 구독 이력 있음). false 면 신규 구독(미구독). 구독 변형 카드의 라벨 분기. */
export function isResubscribe(item: SubscriptionListItem): boolean {
  const status = item.subscription?.status;
  return status === 'canceled' || status === 'expired';
}

/**
 * 결제 변경 가능한가 — 구독 변형(구독중·결제오류·준비중) + 정기결제(빌링키) 주문(`order.type === 'billing'`).
 * 해지·만료·미구독은 재구독 대상이라 제외 — `!isPlantSubscribable` 로 자기완결(호출처 무관).
 *
 * **타입 서술어**인 이유: 통과하면 `order` 가 반드시 존재한다는 사실을 컴파일러에 전달한다. 단순 `boolean`
 * 이면 호출처가 `isPaymentChangeable(item) && item.order && …` 처럼 **런타임에 늘 참인 중복 가드**를 한 번 더
 * 써야 한다(안 쓰면 `order is possibly undefined`). 조건이 여기 한 곳에만 남도록 서술어로 좁힌다.
 */
export function isPaymentChangeable(
  item: SubscriptionListItem,
): item is SubscriptionListItem & { order: PlantOrder } {
  return !isPlantSubscribable(item) && item.order?.type === 'billing';
}
